// src/utils/axiosInstance.js
import axios from 'axios';
import { getToken } from '../services/authService';

const instance = axios.create({
  baseURL: '/api', // 프록시를 통해 요청하므로 상대 경로 사용
  withCredentials: true
});

instance.interceptors.request.use(
  config => {
    const token = getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error),
);

export default instance;
